import React from 'react';

import { AppBar, Typography } from '@mui/material';

import { VerifierCredentialStatus } from 'src/api';
import { useCurrentUserVerifier } from 'src/hooks/verifier';

export const VerifierNotCredentialedBanner: React.FC = () => {
  const { verifier, loading } = useCurrentUserVerifier();

  if (verifier?.credentialStatus === VerifierCredentialStatus.Credentialed || loading) {
    return null;
  }

  return (
    <AppBar style={{ backgroundColor: 'darkorange', textAlign: 'center' }} position="static">
      <Typography p={1.2} color="white" variant="body2">
        Your company is not credentialed yet, that’s why you can’t create and approve requests on
        the platform. Please contact support for assistance.
      </Typography>
    </AppBar>
  );
};
